<script lang="ts">
    let _class: string = '';
    export { _class as class };
</script>

<div class="w-full my-2 
    flex flex-col @md:flex-row gap-2
    {_class}"
    {...$$restProps}
    >
    <slot></slot>
</div>